import { useState } from 'react';

import { getTargetModuleRoute } from './moduleSwitch';

import type { TSmetterModuleSource } from './moduleSwitch';

const SWITCH_ANIMATION_DURATION_MS = 200;

export const useModuleSwitch = (source: TSmetterModuleSource) => {
    const [isSwitching, setIsSwitching] = useState(false);

    const switchModule = () => {
        if (isSwitching) return;

        const targetRoute = getTargetModuleRoute(source);

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            window.location.assign(targetRoute);
            return;
        }

        setIsSwitching(true);
        window.setTimeout(() => window.location.assign(targetRoute), SWITCH_ANIMATION_DURATION_MS);
    };

    return { isSwitching, switchModule };
};
